import React from 'react';
import { useSelector } from 'react-redux';
import { path } from 'ramda';
import { WebContent } from 'js/components/system/WebContent';
import { MY_ACCOUNT_SIDEBAR_REDUCER } from 'js/store/constants';

import { PortalPage as CorePortalPage } from 'js/components/main/MyAccountSidebar/components/Content/components/PortalPage/PortalPage';

export const PortalPage = (props) => {
    const footerWcId = useSelector(path([MY_ACCOUNT_SIDEBAR_REDUCER, 'footerWcId']));

    return (
        <div className={'emulate-mobile sidebar-content'}>
            <CorePortalPage {...props} />
            <WebContent showLoader={false} id={footerWcId} />
        </div>
    );
};
